import React from 'react';
import { Box, Typography, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { DA } from '../platform/navigation/navigation.js';

/**
 * 404 — rendered inside the app layout for signed-in users (header + sidebar stay), on its own
 * for anonymous URLs. Brand tokens, two ways forward (UI review 2026-09-21 §8).
 */
function NotFound() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: { xs: '60vh', md: '70vh' },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        p: { xs: 2, sm: 4 },
      }}
    >
      <Typography variant="h1" sx={{ fontSize: { xs: 72, sm: 110 }, fontWeight: 800, color: 'brand.band', lineHeight: 1 }}>
        404
      </Typography>
      <Typography variant="h5" fontWeight={700} sx={{ mt: 1 }} gutterBottom>
        We couldn&rsquo;t find that page
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3, maxWidth: 420 }}>
        The link may be out of date. Head back to REPSit, or straight into DREW.
      </Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
        <Button variant="outlined" onClick={() => navigate('/')} sx={{ textTransform: 'none', fontWeight: 700 }}>
          Back to REPSit
        </Button>
        <Button variant="contained" endIcon={<ArrowForwardIcon />} onClick={() => navigate(DA)} sx={{ textTransform: 'none', fontWeight: 700 }}>
          Open DREW
        </Button>
      </Stack>
    </Box>
  );
}

export default NotFound;
